export interface FeatureNavigation {
  iconKey: string;
  title: string;
  description: string;
  link: string;
  ariaLabel: string;
}

export const featureNavigationData: FeatureNavigation[] = [
  {
    iconKey: 'book',
    title: 'Catalog',
    description:
      'A community-driven overview of software developed by Equinor. Add your own software projects or find others!',
    link: '/catalog?filters%5Bkind%5D=component&filters%5Buser%5D=all',
    ariaLabel: 'Open the software catalog page',
  },
  {
    iconKey: 'addCircleOutline',
    title: 'Create...',
    description:
      'Powerful templates for performing common tasks to quickly get started or help you improve compliance.',
    link: '/create',
    ariaLabel: 'Open the templates page',
  },
  {
    iconKey: 'libraryBooks',
    title: 'Docs',
    description:
      'All technical documentation in one place! Add your own documentation alongside Radix, Omnia and AppSec.',
    link: '/docs?filters%5Buser%5D=all',
    ariaLabel: 'Open the TechDocs page',
  },
  {
    iconKey: 'search',
    title: 'Search',
    description: 'Powerful search covering the documentation, the catalog and the templates.',
    link: '/search?query=',
    ariaLabel: 'Open the search page',
  },
];
